/**
* 头部菜单
*/
<template>
  <!-- 左边折叠按钮，右边当前门店/角色，点开可退出 -->
  <div class="navbar">
    <el-button class="buttonimg">
      <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
    </el-button>
    <el-dropdown class="user-box" trigger="click" @command="onCommand">
      <span class="user-name">
        <i class="el-icon-user-solid"></i>
        <span v-if="mchName" class="user-mch">{{ mchName }}</span>
        <span>{{ roleName }}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item disabled>{{ loginName }}</el-dropdown-item>
        <el-dropdown-item command="exit" divided>退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { loginout } from '../api/userMG'
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {}
    }
  },
  // 创建完毕状态(里面是操作)
  computed: {
    roleName() {
      const u = this.user || {}
      return (u.roleDto && u.roleDto.roleName) || '管理员'
    },
    mchName() {
      const u = this.user || {}
      return (u.mchDto && u.mchDto.mchName) || ''
    },
    loginName() {
      const u = this.user || {}
      return (u.user && (u.user.userName || u.user.loginName)) || '当前账号'
    }
  },
  created() {
    try {
      this.user = JSON.parse(localStorage.getItem('userdata')) || {}
    } catch (e) {
      this.user = {}
    }
  },
  methods: {
    onCommand(command) {
      if (command === 'exit') this.exit()
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
          // loginout()
          //   .then(res => {
          //     if (res.success) {
          //       //如果请求成功就让他2秒跳转路由
          //       setTimeout(() => {
          //         this.$store.commit('logout', 'false')
          //         this.$router.push({ path: '/login' })
          //         this.$message({
          //           type: 'success',
          //           message: '已退出登录!'
          //         })
          //       }, 1000)
          //     } else {
          //       this.$message.error(res.msg)
          //       this.logining = false
          //       return false
          //     }
          //   })
          //   .catch(err => {
          //     // 获取图形验证码
          //     this.getcode()
          //     this.logining = false
          //     this.$message.error('退出失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}
</script>
<style scoped>
.navbar {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #334157;
  padding-right: 24px;
}
.buttonimg {
  position: relative;
  width: 60px;
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
.user-box {
  cursor: pointer;
}
.user-name {
  color: #fff;
  font-size: 14px;
}
.user-name i {
  margin-right: 4px;
}
.user-mch {
  margin-right: 8px;
  color: rgba(255, 255, 255, 0.75);
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue